/**
 * ProposalsRedirect — the standalone "Game Proposals" card page has been removed;
 * proposals now live in the Games page's "Proposals" tab. Any navigation to the
 * old `/games/proposals` path forwards to that tab on the currently-selected
 * league (falling back to the bare Games page when no league is selected).
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import type { RootState } from '../../store';

const ProposalsRedirect: React.FC = () => {
  const { selectedLeagueId } = useSelector((state: RootState) => state.ui);
  const to = selectedLeagueId ? `/leagues/${selectedLeagueId}/games?tab=proposals` : '/games';
  return <Navigate to={to} replace />;
};

export default ProposalsRedirect;
